window.addEventListener('scroll', function() {
    if (document.body.classList.contains('page-template-front-page')) {
        const scrollPosition = window.scrollY;
        const backgroundImage = document.querySelector('.header-background-image');
        
        // Adjust the parallax speed by changing the divisor value
        backgroundImage.style.transform = 'translateY(' + scrollPosition * 0.2 + 'px)';
    }
});